// extracted by mini-css-extract-plugin
export default {"container":"info_container__ZjQ7Y","item":"info_item__WmzLx","label":"info_label__hxJbo","text":"info_text__thoPs"};